import React from "react";

interface DotProps {
  color: string;
  size?: number;
  className?: string;
}

export const Dot = ({ color, size = 10, className = "" }: DotProps) => (
  <span
    className={`dot ${className}`}
    style={{
      backgroundColor: color,
      width: size,
      height: size,
    }}
  />
);
